/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { Modal, Nav } from "rsuite";
import { MdPersonAddAlt } from "react-icons/md";
import { GoHome } from "react-icons/go";
import { FiAlertTriangle } from "react-icons/fi";
import { IoSettingsOutline } from "react-icons/io5";
import "./common.css";

const SideMenu = ({ ClickItem }) => {
  const { auth, formNavigation, setFormNavigation } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.pathname || "/";
  const [selectedItem, setSelectedItem] = useState("");
  const [modelOpen, setModelOpen] = useState(false);

  const allowedPages = [
    "User Master",
    "Equipment Master",
    "Iot Devices Master",
    "Machine Breakdown hrs",
    "Approvals",
    "Device Firmware Update",
  ];

  return (
    <div className="h-100 d-flex justify-content-between flex-column">
      <div>
        <div className="d-flex flex-row justify-content-center pt-10 pb-10">
          <img
            src={require("../assets/logo.jpg")}
            className="logo"
            alt="logo"
          />
        </div>
        <Nav
          style={{ maxHeight: "83vh", overflowY: "auto" }}
          appearance="subtle"
          vertical
          activeKey={
            from === "/"
              ? "dashboard"
              : from === "/operational-dashboard"
                ? "op-dashboard"
                : from === "/administrator" ||
                    from === "/administratorMasterData" ||
                    from === "/equipmentDetails" ||
                    from === "/deviceFirmwareUpdate" ||
                    from === "/masterRunninghrs"
                  ? "administrator"
                  : from === "/alerts"
                    ? "alerts"
                    : from === "/settings"
                      ? "settings"
                      : ""
          }
          onSelect={(event) => {
            setSelectedItem(event);
            ClickItem(event);
            if (formNavigation) {
              setModelOpen(true);
            } else {
              if (event === "dashboard") {
                navigate("/");
              } else if (event === "op-dashboard") {
                navigate("/operational-dashboard");
              } else if (event === "administrator") {
                navigate("/administrator");
              } else if (event === "alerts") {
                navigate("/alerts");
              } else if (event === "settings") {
                navigate("/settings");
              }
            }
          }}
        >
          {auth?.pages?.includes("HO Dashboard") && (
            <Nav.Item eventKey="dashboard" icon={<GoHome />}>
              Dashboard
            </Nav.Item>
          )}

          {auth?.pages?.includes("Operational Dashboard") && (
            <Nav.Item eventKey="op-dashboard" icon={<GoHome />}>
              Dashboard
            </Nav.Item>
          )}

          {allowedPages.some((page) => auth?.pages?.includes(page)) && (
            <Nav.Item eventKey="administrator" icon={<MdPersonAddAlt />}>
              Administrator
            </Nav.Item>
          )}

          {auth?.pages?.includes("Alerts") && (
            <Nav.Item eventKey="alerts" icon={<FiAlertTriangle />}>
              Alerts
            </Nav.Item>
          )}

          <Nav.Item eventKey="settings" icon={<IoSettingsOutline />}>
            Settings
          </Nav.Item>
        </Nav>
      </div>
      <div className="d-flex flex-row justify-content-center textColor fs-10">
        Version: 1.1.5
      </div>
      <Modal
        open={modelOpen}
        onClose={() => {
          setModelOpen(false);
        }}
        keyboard={false}
        className="modelbordercolor"
        style={{ transform: " translate(0px,200px)" }}
        size={"xs"}
      >
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className="h-20">
            <div className="text-center">
              <span>
                {" "}
                Are you sure you want to exit? All unsaved data will be lost.
              </span>
            </div>
            <div className="d-flex flex-row justify-content-center mt-25">
              <button
                className="btn ml-auto bg-black mr-10 w-20 Cancel"
                onClick={() => {
                  setModelOpen(false);
                }}
              >
                Cancel
              </button>
              <button
                className="btn addBtn ml-auto w-20"
                onClick={() => {
                  setFormNavigation(false);
                  setModelOpen(false);
                  if (selectedItem === "dashboard") {
                    navigate("/");
                  } else if (selectedItem === "administrator") {
                    navigate("/administrator");
                  } else if (selectedItem === "alerts") {
                    navigate("/alerts");
                  } else if (selectedItem === "settings") {
                    navigate("/settings");
                  }
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
};

export default SideMenu;
